<template lang="pug">
  .teachers-list
    v-list
      v-subheader Преподаватели группы
      v-list-item(v-if="!groupTeachers.length")
        v-list-item-content Не назначены...
      v-list-item(
        v-for="t in groupTeachers"
        :key="t.id"
        :close="isOrganization"
      )
        v-list-item-avatar
          v-icon mdi-account
        v-list-item-content {{ t.full_name }}
        v-list-item-action
          v-btn(icon small)
            v-icon(@click="openDeleteDialog(t.id)" small) mdi-close

      // Добавление учителей
      .my-2
        sdo-dialog(
          v-if="isOrganization || isCurator"
          :button-options="{ class: 'ma-2', label: 'Добавить', icon: 'mdi-plus', color: 'success' }"
        )
          template(v-slot:header) Добавить преподавателей
          template(v-slot:body)
            server-data(
              ref="serverData"
              v-slot="{ serverData, selectProps, loadMoreItems, search }"
              :query="{ 'search[organization]': organizationId }"
              :serializeData="serializeData"
              searchFieldName="search[name]"
              :method="$api.teachers.index"
            )
              v-autocomplete-more(
                v-model="selectedTeachers"
                v-bind="selectProps"
                item-text="full_name"
                item-value="id"
                color="secondary"
                multiple
                rounded
                small-chips
                cache-items
                hide-details
                outlined
                deletable-chips
                label="Выберите преподавателей"
                large
                @update:search-input="search"
                @load-more-items="$refs.serverData.loadMoreItems"
              )
          template(v-slot:actions="{ close }")
            v-spacer
            v-btn(@click="addGroupTeachers(close)" color="success" rounded text) Добавить
            v-btn(@click="close()" color="warning" rounded text) Закрыть

      delete-dialog(v-model="showDeleteDialog" @delete="onTeacherDelete")
        template(v-slot:body) Вы действительно хотите удалить данного преподавателя?
</template>

<script>
import { mapGetters } from 'vuex';

import GroupService from '@/services/API/GroupService';
import SdoDialog from '@/components/Global/SdoDialog.vue';

export default {
  name: 'GroupViewTeachers',
  components: { SdoDialog },
  props: {
    groupId: {
      type: Number,
      default: 0,
    },
    courseId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      curatorIds: [],
      groupTeachers: [],
      courseTeachers: [],
      selectedTeachers: [],
      showDeleteDialog: false,
    };
  },
  computed: {
    ...mapGetters({ isOrganization: 'auth/isOrganization' }),
    organizationId() {
      const organization = this.isOrganization
        ? this.$user.organization : this.$user.data.organizations[0];
      return organization.id;
    },
    isCurator() {
      return this.curatorIds.includes(this.$user.data.id);
    },
    filterCourseTeacher() {
      return this.courseTeachers.filter(
        (courseTeacher) => (
          !this.groupTeachers.some(
            (groupTeacher) => (
              courseTeacher.id === groupTeacher.id
            ),
          )
        ),
      );
    },
  },
  mounted() {
    this.getGroupTeachers(this.groupId);
  },
  created() {
    this.getCurators();
  },
  methods: {
    serializeData(data) {
      return data.filter(
        (courseTeacher) => (
          !this.groupTeachers.some(
            (groupTeacher) => (
              courseTeacher.id === groupTeacher.id
            ),
          )
        ),
      );
    },
    resetSelectedTeachers() {
      this.selectedTeachers = [];
    },
    getGroupTeachers(id) {
      this.$rHandler(
        GroupService.getGroupTeachers(id),
        (r) => {
          this.groupTeachers = r.data.data;
        },
      );
    },
    async getCurators() {
      const { items } = await this.$api.users.index({
        'search[curator_course_id]': this.courseId,
      });
      this.curatorIds = items.map((i) => i.id);
    },
    addGroupTeachers(closeFunc) {
      const data = {
        teachers: this.selectedTeachers,
      };
      this.$rHandler(
        GroupService.addGroupTeachers(this.groupId, data),
        () => {
          this.resetSelectedTeachers();
          this.getGroupTeachers(this.groupId);
          this.$toasted.success('Преподаватели добавлены', { duration: 3000 });
          closeFunc();
        },
      );
    },
    openDeleteDialog(teacherId) {
      this.deleteId = teacherId;
      this.showDeleteDialog = true;
    },
    onTeacherDelete() {
      const data = {
        teachers: [this.deleteId],
      };
      this.$rHandler(
        GroupService.deleteGroupTeachers(this.groupId, data),
        () => {
          this.getGroupTeachers(this.groupId);
          this.$toasted.success('Преподаватель удален', { duration: 3000 });
          this.showDeleteDialog = false;
        },
      );
    },
  },
};
</script>
